import React from 'react';
import InputElement from 'react-input-mask';
import FieldValidation from '../Fragments/FieldValidation';
import FieldError from '../Fragments/FieldError';
import moment from 'moment';
let Validation = require('../Managers/Validation.js');
let Quote = require('../Managers/Quote');
let dateFormat = 'DD/MM/YYYY';

const DateOfBirth = React.createClass({
    propTypes: {
        fieldName:    React.PropTypes.string.isRequired,
        question:     React.PropTypes.string.isRequired,
        loadCachedValue: React.PropTypes.bool.isRequired
    },

    getInitialState() {
        return {
            hasError: false,
            isValid: (Quote.getCurrentAnswer(this.props.fieldName)) ? true : false,
            formattedDate : ''
        };
    },

    doValidation() {
        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        return true;
    },

    onBlur(e) {
        e.preventDefault();
        let day = ('0' + document.getElementById('dob-day').value).slice(-2);
        let month = ('0' + document.getElementById('dob-month').value).slice(-2);
        let year = document.getElementById('dob-year').value;

        // Don't fire any kind of validation unless a year has been provided in
        // the requested format
        if (year !== '' && year.length === 4 && month != '0' && day != '0') {
            let enteredDate = year + '-' + month + '-' + day;

            let validation = Validation.validate(this.props.fieldName, enteredDate)[0];
            this.setState(validation);

            if (validation.isValid) {
                this.setState({
                    formattedDate : moment(enteredDate).format(dateFormat)
                });
                Quote.set(this.props.fieldName, moment(enteredDate).format(dateFormat));
            } else {
                window.removeLocalStorageAnswer('date_of_birth_at');
            }
        } else {
            this.setState({
                isValid: false
            });
            window.removeLocalStorageAnswer('date_of_birth_at');
        }
    },

    render: function() {
        let av = Quote.getCurrentAnswer(this.props.fieldName);
        if (av !== null) {
            av = av.split("/");
        }
        let avDay = (av !== null) ? av[0].replace(/^0+/, '') : null;
        let avMonth = (av !== null) ? av[1].replace(/^0+/, '') : null;
        let avYear = (av !== null) ? av[2] : null;

        return (
            <div>
                <question-row>
                    <div className="question-main date-selector">
                        <div className="question-top">
                            <label>{this.props.question}</label>
                        </div>
                        <div className="question-input">
                            <div className="input-column">
                                <label htmlFor="dob-day" className="sr-only">Day</label>
                                <select
                                    name="dob-day"
                                    id="dob-day"
                                    className="form-control"
                                    onBlur={this.onBlur}
                                    placeholder="Day"
                                    defaultValue={avDay}
                                >
                                    <option value="" />
                                    {Array.apply(0, Array(31)).map(function (x, i) {
                                        let day = String(i + 1);
                                        return <option key={day} value={day}>{day}</option>;
                                    })}
                                </select>
                            </div>
                            <div className="input-column">
                                <label htmlFor="dob-month" className="sr-only">Month</label>
                                <select
                                    name="dob-month"
                                    id="dob-month"
                                    className="form-control"
                                    onBlur={this.onBlur}
                                    placeholder="Month"
                                    defaultValue={avMonth}
                                >
                                    <option value="" />
                                    {Array.apply(0, Array(12)).map(function (x, i) {
                                        let month = String(i + 1);
                                        return <option key={month} value={month}>{moment().month(i).format('MMM')}</option>;
                                    })}
                                </select>
                            </div>
                            <div className="input-column">
                                <label htmlFor="dob-year" className="sr-only">Year</label>
                                <InputElement
                                    name="dob-year"
                                    id="dob-year"
                                    className="form-control"
                                    placeholder="E.g. 1982"
                                    mask="9999"
                                    maskChar={null}
                                    onBlur={this.onBlur}
                                    defaultValue={avYear}
                                />
                                <input
                                    type="hidden"
                                    name={this.props.fieldName}
                                    id={this.props.fieldName}
                                    value={this.state.fullDate}
                                />
                            </div>
                        </div>
                        {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                    </div>
                    <div className="question-extra">
                        <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                    </div>
                </question-row>
            </div>
        );
    }
});

export default DateOfBirth;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/DateOfBirth.js
 **/